import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["actions"];

  showLoaderOnRemoveOrResend() {
    this.showLoaderInElement(this.actionsTarget);
  }

  showLoaderInElement(element) {
    if (!element) return;

    const loader = this.renderElementLoader();

    element.innerHTML = "";
    element.style.width = "2em";
    element.style.height = "2em";
    element.style.position = "relative";

    element.appendChild(loader);
  }

  renderElementLoader() {
    const loader = document.createElement("div");
    loader.id = "loader-element";

    loader.style.position = "absolute";
    loader.style.width = "2em";
    loader.style.zIndex = "10000";

    loader.innerHTML = '<div class="inline-spinner"></div>';

    return loader;
  }
}
